import FormErrors from "@/components/FormErrors/FormErrors";
import HmAutocompleteObject from "@/components/Autocomplete/AutocompleteObject.vue";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";
import uuidv4 from "uuid/v4";
import { JSConn } from "@/utilities/js-conn";
import { find as Rfind, propEq as RpropEq } from "ramda";

export default {
  name: "clientFieldEditForm",
  components: {
    FormErrors,
    HmAutocompleteObject,
    LoadingAnimation,
  },
  props: {
    clientFieldId: String,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage: "Loading Field...",
      hasFormErrors: false,
      formErrors: [],
      clientField: {},
      cancelParams: { name: "clientFields" },
    };
  },
  created() {
    // retrieve the data for the autocompletes
    const jsConnClients = new JSConn();
    const jsConnCommodities = new JSConn();

    if (this.clientFieldId === "new") {
      jsConnClients.formParams = {
        statuses: ["active"],
      };
    } else {
      jsConnClients.formParams = {};
    }

    jsConnCommodities.formParams = {};

    const dataPromises = [
      this.$store.dispatch("needClients", jsConnClients),
      this.$store.dispatch("needCommodities", jsConnCommodities),
    ];

    Promise.all(dataPromises).then(() => {
      if (this.clientFieldId === "new") {
        this.clientField = {
          id: uuidv4(),
          name: "New",
          description: null,
          acres: 0,
          client: {},
          client_id: null,
          commodity: {},
          commodity_id: null,
          map_url: null,
        };
        this.dataLoaded = true;
        this.$nextTick(() => this.$refs.firstInput.select());
      } else {
        const jsConn = new JSConn();
        jsConn.formParams = {
          id: this.clientFieldId,
        };

        this.$store.dispatch("needClientField", jsConn).then(() => {
          // correct field is in the store
          this.clientField = {
            id: this.apiClientField.id,
            name: this.apiClientField.name,
            description: this.apiClientField.description,
            acres: this.apiClientField.acres,
            client_id: this.apiClientField.client_id,
            commodity_id: this.apiClientField.commodity_id,
            map_url: this.apiClientField.map_url,
          };

          this.clientField.client = Rfind(
            RpropEq("value", this.clientField.client_id),
            this.clientsForAutocomplete,
          );
          this.clientField.commodity = Rfind(
            RpropEq("value", this.clientField.commodity_id),
            this.commoditiesForAutocomplete,
          );
          this.dataLoaded = true;
          this.$nextTick(() => this.$refs.firstInput.select());
        });
      }
    });
  },
  computed: {
    apiClientField: function() {
      return this.$store.getters.clientField;
    },
    clientsForAutocomplete: function() {
      return this.$store.getters.clientsForAutocomplete;
    },
    commoditiesForAutocomplete: function() {
      return this.$store.getters.commoditiesForAutocomplete;
    },
  },
  methods: {
    submitForm(evt) {
      evt.preventDefault();
      const jsConn = new JSConn();
      jsConn.formParams = this.clientField;
      jsConn.toRoutePath = "/client-fields";

      let storeDispatch;

      if (this.clientFieldId === "new") {
        storeDispatch = "createClientField";
      } else {
        storeDispatch = "updateClientField";
      }

      this.$store
        .dispatch(storeDispatch, jsConn)
        .then(jsConn => {
          this.$router.push(jsConn.toRoutePath);
          return Promise.resolve(jsConn);
        })
        .catch(jsConn => {
          this.hasFormErrors = true;
          this.formErrors = jsConn.error["response"]["data"];
        });
    },
    updateClient(evt) {
      this.clientField.client = evt;
      this.clientField.client_id = evt.value;
    },
    updateCommodity(evt) {
      this.clientField.commodity = evt;
      this.clientField.commodity_id = evt.value;
    },
    showDeleteModal() {
      this.$refs["deleteModal"].show();
    },
    hideDeleteModal() {
      this.$refs["deleteModal"].hide();
    },
    deleteClientField() {
      const jsConn = new JSConn();
      jsConn.toRoutePath = "/client-fields";
      jsConn.formParams = {
        id: this.clientFieldId,
      };
      this.$store.dispatch("deleteClientField", jsConn).then(jsConn => {
        this.$router.push(jsConn.toRoutePath);
        return Promise.resolve(jsConn);
      });
    },
  },
};
